module.exports = __webpack_public_path__ + "static/img/48-5.611c1a0.png";